// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qb-0";